import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { Container } from 'react-bootstrap';
import { SITELINK } from '../../../../constants/softwareProviders';
import StandardUnitListingComponent from '../../../../src/web/components/rentalCenter/StandardUnitListing';
import withAlert from '../../../hocs/withAlert';
import useCurrentSite from '../../../../modules/react/hooks/useCurrentSite';
import useQuery from '../../../../modules/react/hooks/useQuery';

const propTypes = {
  alert: PropTypes.node,
  id: PropTypes.string,
  corp: PropTypes.string,
  site: PropTypes.string,
  content: PropTypes.string,
  isBuilderView: PropTypes.bool.isRequired,
  pageFacilityId: PropTypes.string,
};

const defaultProps = {
  alert: undefined,
  id: undefined,
  corp: undefined,
  site: undefined,
  content: undefined,
  pageFacilityId: undefined,
};

const GET_APPLICABLE_FACILITIES = gql`
  query ApplicableFacilities {
    applicableFacilities {
      applicableFeesEnabled
      state
      id
    }
  }
`;

const GET_APPLICABLE_STATES = gql`
  query ApplicableFeeSettings {
    applicableFeeSettings {
      states {
        enabled
        state
      }
    }
  }
`;

const StandardUnitListing = ({ alert, content, corp, site, isBuilderView, id, pageFacilityId }) => {
  const builderViewPadding = isBuilderView ? 20 : '';
  const { showApplicableFees } = useCurrentSite();

  const { data, loading: facilitiesLoading,
    error: facilitiesError } = useQuery(GET_APPLICABLE_FACILITIES, {
    fetchPolicy: 'no-cache',
    ssr: false,
  });

  const { data: statesData,
    loading: statesLoading, error: statesError } = useQuery(GET_APPLICABLE_STATES, {
    fetchPolicy: 'no-cache',
    ssr: false,
  });

  const [showFees, setShowFees] = useState(null);
  const [isReady, setIsReady] = useState(false);

  const calculateOutcome = (showApplicableFee, stateEnabled, facilitySetting) => {
    if (stateEnabled) {
      if (showApplicableFee === null || showApplicableFee === true) {
        return facilitySetting === null || facilitySetting === true;
      }
    }
    return false;
  };

  useEffect(() => {
    if (facilitiesLoading || statesLoading) {
      return;
    }

    if (facilitiesError || statesError || !pageFacilityId) {
      setShowFees(false);
      setIsReady(true);
      return;
    }

    const { applicableFacilities } = data;
    const states = statesData?.applicableFeeSettings?.states || [];

    if (applicableFacilities.length === 0) {
      setShowFees(false);
      setIsReady(true);
      return;
    }

    const pageFacility = applicableFacilities.find(facility => facility.id === pageFacilityId);

    if (!pageFacility) {
      setShowFees(false);
      setIsReady(true);
      return;
    }

    const facilitySetting = pageFacility?.applicableFeesEnabled;
    const facilityState = states.find(state => state.state === pageFacility?.state);

    const outcome = calculateOutcome(showApplicableFees, facilityState?.enabled, facilitySetting);
    setShowFees(outcome);
    setIsReady(true);
  }, [data, statesData, pageFacilityId,
    showApplicableFees, facilitiesLoading, statesLoading, facilitiesError, statesError]);

  if (facilitiesLoading || statesLoading || !isReady) {
    return (
      <Container>
        <p>Please wait...</p>
      </Container>
    );
  }

  return (
    <>
      <Container>
        {alert && alert}
      </Container>
      <div
        style={{ width: '100%', padding: builderViewPadding }}
        className="pb-no-click"
      >
        <StandardUnitListingComponent
          showApplicableFees={showFees}
          key={id}
          style={{ width: '100%', padding: builderViewPadding }}
          content={content}
          corp={corp}
          site={site}
        />
      </div>
    </>
  );
};

StandardUnitListing.propTypes = propTypes;
StandardUnitListing.defaultProps = defaultProps;

export default withAlert({
  Component: StandardUnitListing,
  message: 'If you need to reserve a unit, please try again later or give us a call.',
  providers: [SITELINK],
});
